import type { RelatedBulletin } from '../types';

const RESPONSE_STATUS_LABELS: Record<string, string> = {
  pending: 'Ожидает ответа',
  accepted: 'Принят',
  rejected: 'Отклонен',
  withdrawn: 'Отозван',
  declined: 'Отклонен',
  cancelled: 'Отменен',
};

export const formatResponseStatusLabel = (status: string): string => {
  const key = (status || '').toLowerCase();
  return RESPONSE_STATUS_LABELS[key] || status || 'Без статуса';
};

/** Основная подпись: подкатегория на русском + класс. */
export const formatBulletinPrimaryLabel = (bulletin: RelatedBulletin): string => {
  const sub = bulletin.subcategory_ru?.trim();
  const title = bulletin.title?.trim();
  const looksLikeSlug =
    !!title &&
    (/^[a-z0-9]+(?:[_-][a-z0-9]+)*$/i.test(title) ||
      /^[a-z0-9_-]+\s-\s[a-z0-9_-]+$/i.test(title));
  const grade =
    title && /\d+\s*класс/.test(title)
      ? title.match(/\d+\s*класс/)?.[0]
      : null;

  if (sub) {
    return grade ? `${sub} - ${grade}` : sub;
  }
  if (title && !looksLikeSlug) {
    return title;
  }
  return `Заявка #${bulletin.bulletin_id}`;
};

export const formatBulletinOptionLabel = (bulletin: RelatedBulletin): string =>
  formatBulletinPrimaryLabel(bulletin);

export const formatBulletinOptionSubtitle = (bulletin: RelatedBulletin): string => {
  const status = formatResponseStatusLabel(bulletin.status);
  if (bulletin.bulletin_closed) {
    return `Заявка закрыта - ${status}`;
  }
  return bulletin.active ? `Отклик активен - ${status}` : `Отклик неактивен - ${status}`;
};
